import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableTruncate',
  props: {
    value: {},
    separator: { default: ', ' },
    size: { default: 'lg' }
  },
  setup(__props: any) {

    const props = __props;

    const sizes = {
        sm: 'max-w-[100px] lg:max-w-sm',
        md: 'max-w-[150px] lg:max-w-md',
        lg: 'max-w-xs lg:max-w-xl xl:max-w-4xl',
    };

    const displayText = computed(() => {
        return Array.isArray(props.value) ? props.value.join(props.separator) : props.value;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["truncate", sizes[_ctx.size]]),
    title: displayText.value
  }, _toDisplayString(displayText.value), 11, _hoisted_1))
}
}

})